import { useCallback, useEffect, useState } from 'react';
import labelTasksService from '../../../services/labelTasks';
import { LabelTask, LineupEntry } from '../../../services/sessionModels';

export function useSessionLineup(sessionId?: number | string | null) {
  const [lineup, setLineup] = useState<LineupEntry[]>([]);

  useEffect(() => {
    if (!sessionId) return;
    let cancelled = false;
    labelTasksService.getLineup(sessionId).then((result) => {
      if (!cancelled) setLineup(result?.items ?? []);
    });
    return () => {
      cancelled = true;
    };
  }, [sessionId]);

  return lineup;
}

export function useSessionLabelTasks(sessionId?: number | string | null) {
  const [labelTasks, setLabelTasks] = useState<LabelTask[] | undefined>(undefined);

  const refetch = useCallback(async () => {
    if (!sessionId) return;
    const result = await labelTasksService.getLabelTasks(sessionId);
    setLabelTasks(result?.items ?? []);
  }, [sessionId]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { labelTasks, refetch };
}
